const gameIndex = resolve => require(['@/games/pages/common/index'], resolve);
export default [
    {
        path: '/games',
        name: 'games',
        redirect: '/games',
        meta: {
            title: 'hd.game'
        },
        component: gameIndex,
        children: [
            {
                path: '/games/dice',
                name: 'dice',
                meta: {
                    title: 'game.rollDice'
                },
                component: resolve => require(['@/games/pages/views/dice/index.vue'], resolve)
            }, {
                path: '/dice/banker/:id',
                name: 'banker',
                meta: {
                    title: 'game.becomeDealer'
                },
                component: resolve => require(['@/games/pages/views/dice/banker/index.vue'], resolve)
            }, {
                path: '/dice/historybooks',
                name: 'historybooks',
                meta: {
                    title: 'game.rettingRecord'
                },
                component: resolve => require(['@/games/pages/views/dice/historybooks/index.vue'], resolve)
            }
        ]
    },

]




// WEBPACK FOOTER //
// ./src/router/main/games.js